import React from "react";
import "../styles/CommitDetails.css";
import { VsoLink, TeamsChat } from './CommonElements.tsx'
import { Title3, Subtitle2 } from "@fluentui/react-components";
import { format, parseISO } from "date-fns";
import { CommitDetails } from "../interfaces/CommitDetails.ts";
import { Service } from "../interfaces/Service";

interface MetaDataCardProps {
  service: Service;
  commitDetails: CommitDetails;
  env: string;
  processId: string;
  metric: string;
}

function formatDate(dateString: string): string {
  return format(parseISO(dateString), "EEEE MMMM do, yyyy. HH:mm:ss");
}

const MetaDataCard: React.FC<MetaDataCardProps> = ({ service, commitDetails, env, processId, metric }) => {
  const commitMetaData = commitDetails.commitMetaData;
  const { title, authorName, prMergeDate } = commitMetaData;
  const mergedLabel = prMergeDate ? formatDate(prMergeDate) : 'merge date unavailable';
  
  return (
    <div className="metaDataCard">
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Title3>{title}</Title3>
        <Subtitle2>{authorName}, merged {mergedLabel}</Subtitle2>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <VsoLink commitMetadata={commitMetaData} service={service} />
        <TeamsChat serviceId={service.id} commitDetails={commitDetails} env={env} processId={processId} metric={metric}/>
      </div>
    </div>
  );
}

export default MetaDataCard;